import {
  generateProductItemUrl
} from "./chunk-XV7TMGN6.mjs";

// src/ItemCodeRedirect.tsx
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Fragment, jsx } from "react/jsx-runtime";
var ITEM_CODE_PARAM = "ic";
var resolveItemUrl = async (httpClient, rawCode) => {
  const itemcode = rawCode.trim().toUpperCase();
  if (!itemcode) {
    return null;
  }
  const { data: search } = await httpClient.post("/search", [
    { columnName: "ItemCode", operator: "eq", value: itemcode }
  ]);
  const item = search.items[0];
  if (!item) {
    return null;
  }
  const { data: group } = await httpClient.get(
    `/group/${item.groupid}/name`
  );
  return generateProductItemUrl(group.groupName, item.itemcode);
};
var createItemCodeRedirect = (httpClient) => {
  const ItemCodeRedirect = ({ children }) => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const code = searchParams.get(ITEM_CODE_PARAM);
    useEffect(() => {
      if (!code) {
        return;
      }
      let cancelled = false;
      resolveItemUrl(httpClient, code).then((url) => {
        if (cancelled) {
          return;
        }
        if (url) {
          navigate(url, { replace: true });
          return;
        }
        console.error(`No item found for code "${code}"`);
        dropParam();
      }).catch((error) => {
        if (cancelled) {
          return;
        }
        console.error("Failed to resolve item code:", error);
        dropParam();
      });
      function dropParam() {
        const next = new URLSearchParams(searchParams);
        next.delete(ITEM_CODE_PARAM);
        setSearchParams(next, { replace: true });
      }
      return () => {
        cancelled = true;
      };
    }, [code]);
    return code ? null : /* @__PURE__ */ jsx(Fragment, { children });
  };
  return ItemCodeRedirect;
};
export {
  createItemCodeRedirect,
  resolveItemUrl
};
